<template>
  <mw-dialog :size="params.size" :width="width" :height="height"  ref="dialog" :title="$lang(params.title?params.title:'选择')" :appendToBody="false" :footerButton="footerButton" :before-close="selectCancel">
    <mw-tree :url="params.url" :singleLeaf="(params.singleLeaf!=undefined)?params.singleLeaf:true" :async="params.async?params.async:false" :expandedFirst="true"
             ref="tree" :selectFirst="(params.selectFirst!=undefined)?params.selectFirst:false"
             :defaultParentId="params.defaultParentId" :dragEnable = "dragEnable"
             :aliasId="params.aliasId" :checkNodes="params.checkNodes" :selectNode="params.selectNode"
             :treeData="params.treeData"
             :types="(params.types!=undefined) ? params.types : null"
             @ready="params.ready"
             :multipleLeaf="(params.multipleLeaf!=undefined)?params.multipleLeaf:false" :multiple="params.multiple?params.multiple:false"
             :defaultParams="params.defaultParams" :restful="(params.restful!=undefined)?params.restful:false" :threeState="params.threeState" :search="params.search?params.search:false"></mw-tree>
  </mw-dialog>
</template>

<script>
  export default {
    props: {
      /**
       *  params.data
       *  url:  必须
       *  title:选择  （可选）
       *  size:mini_small    （可选）
       *  clearBtn: true为启用清除按钮，默认有
       *  ready：树加载完事件
       *  buttonsScript: 额外处理按钮
       *  sureName: 确定按钮名称
       *  cancelName: 取消按钮名称
       */
      params: {
        type: Object
      }
    },
    data() {
      let me=this;
      return {
        width:this.params.width || (this.params.size?null:"400px"),
        height:this.params.height || (this.params.size?null:"60vh"),
        dragEnable:!this.params.dragEnable,
        footerButton: [
          {label:$lang(me.params.sureName || '确定'), func: this.selectSure},
          {label:$lang(me.params.cancelName || '取消'), func: this.selectCancel, type: 'default'},
        ]
      }
    },
   created(){
      let me=this;
      if(me.params.buttonsScript)
        eval(me.params.buttonsScript);
      if(me.params.clearBtn ==undefined || me.params.clearBtn){
          this.footerButton.unshift({
            label: $lang('清除'),
            func:this.clearSure,
            type: 'default'
          })
      }
   },
    mounted() {
      setTimeout(()=>{
        this.show();
      },200)
    },
    watch: {
      'params.url'() {
      }
    },
    methods: {
      selectSure() {
        let me=this,data = this.mwRef('tree').getSelected();
        if(!data){
           return;
        }
        let multiple=me.params.multiple?me.params.multiple:false;
        if(multiple){
          if(data.length > 0){
            if(me.params.callCancel){
              me.params.func(data,me.selectCancel);
            }else{
              me.params.func(data);
            }
          }else{
            if(me.params && me.params.noDefaultMsg){
              me.params.func();
            }else{
              me.mwMsg("warning","请选择相应条目！");
            }
          }
        }else{
          if(!(data instanceof Array) ){
            if(me.params.callCancel){
              me.params.func(data,me.selectCancel);
            }else{
              me.params.func(data);
            }
          }
        }
        if(!me.params.callCancel){
          me.selectCancel();
        }
      },
      selectCancel() {
        this.mwRef('dialog').hide();
        if(this.params.search){
          this.mwRef('tree').resetSearchText();
        }
        if(this.params.checkNodes){
          this.params.checkNodes=[];
        }
        if(this.params.selectNode){
          this.params.selectNode='';
        }
      },
      clearSure(){
         let me=this;
         this.mwRef('tree').unCheckAll();
         let multiple=me.params.multiple?me.params.multiple:false;
         if(multiple){
            me.params.func([{}]);
         }else{
            me.params.func({});
         }
         me.selectCancel();
      },
      show() {
        this.mwRef('dialog').show();
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/components/tree.vue